/**
 * A filled circle with a check: the run-history marker for a completed run.
 * Tints via `fill`, taking the same `size` and `className` props as the lucide
 * icons beside it.
 */
export function RunCompletedIcon({
  className,
  size = 14,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 14 14'
      fill='none'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M6.66667 0C2.98667 0 0 2.98667 0 6.66667C0 10.3467 2.98667 13.3333 6.66667 13.3333C10.3467 13.3333 13.3333 10.3467 13.3333 6.66667C13.3333 2.98667 10.3467 0 6.66667 0ZM5.33333 10L2 6.66667L2.94 5.72667L5.33333 8.11333L10.3933 3.05333L11.3333 4L5.33333 10Z'
        fill='currentColor'
      />
    </svg>
  );
}

/**
 * A filled circle with an exclamation: the run-history marker for a failed run.
 * Tints via `fill`, taking the same `size` and `className` props as the lucide
 * icons beside it.
 */
export function RunFailedIcon({
  className,
  size = 14,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 14 14'
      fill='none'
      className={className}
      aria-hidden='true'
    >
      <path
        d='M6.66667 0C2.98667 0 0 2.98667 0 6.66667C0 10.3467 2.98667 13.3333 6.66667 13.3333C10.3467 13.3333 13.3333 10.3467 13.3333 6.66667C13.3333 2.98667 10.3467 0 6.66667 0ZM7.33333 10H6V8.66667H7.33333V10ZM7.33333 7.33333H6V3.33333H7.33333V7.33333Z'
        fill='currentColor'
      />
    </svg>
  );
}
